module.exports = __webpack_public_path__ + "img/gift1.9c0206d3.png";